<template>
  <v-flex>
    <v-card>
      <v-layout row wrap align-center>
        <v-flex xs12 sm12>
          <v-alert
            v-if="invites_errors"
            :value="true"
            color="error"
            icon="warning"
            outline
          >
            <div v-for="(v, k) in invites_errors" :key="k">
              <p v-for="error in v" :key="error" class="text-sm">
                {{ error }}
              </p>
            </div>
          </v-alert>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-subheader v-text="'Name'"></v-subheader>
        </v-flex>
        <v-flex xs12 sm6>
          <v-flex sm12>
            <v-text-field v-model="invites_name" label="Name"></v-text-field>
          </v-flex>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-subheader v-text="'GSMG user ID'"></v-subheader>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
            v-model="gsmg_user_id"
            label="GSMG user ID"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-subheader v-text="'ETH address'"></v-subheader>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
            v-model="invites_eth_addr"
            label="ETH address"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-subheader v-text="'BNB address'"></v-subheader>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
            v-model="invites_bnb_addr"
            label="BNB address"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-subheader v-text="'Revenue share (%)'"></v-subheader>
        </v-flex>
        <v-flex xs12 sm6>
          <v-text-field
            v-model="ref_share_pct"
            label="Revenue share (%)"
          ></v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center>
        <v-flex xs12 sm6>
          <v-btn dark color="primary" @click="createPartner">
            Save
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import axios from "axios";
import swal from "sweetalert2";
import { mapGetters } from "vuex";

export default {
  name: "AddPartner",
  data: function() {
    return {
      invites_name: "",
      invites_eth_addr: "",
      invites_bnb_addr: "",
      gsmg_user_id: null,
      ref_share_pct: 0,
      invites_errors: null
    };
  },
  computed: {
    ...mapGetters({
      themeDark: "settings/darkmode"
    })
  },
  created: async function() {
    await axios.get("/api/v1/admin/getPartnersDefaults").then(res => {
      this.ref_share_pct = res.data.ref_share_pct;
    });
  },
  methods: {
    createPartner: async function() {
      if (this.invites_name.length) {
        await axios
          .post("/api/v1/admin/generateInvite", {
            name: this.invites_name,
            eth_addr: this.invites_eth_addr,
            bnb_addr: this.invites_bnb_addr,
            user_id: this.gsmg_user_id,
            ref_share_pct: this.ref_share_pct
          })
          .then(async response => {
            this.invites_errors = null;

            if (response.data) {
              const urls = response.data.join("<br>");

              await swal({
                title: "Partner added",
                html: "<h3>Partner invite link:</h3> <br/>" + urls,
                width: "80%",
                showCloseButton: true,
                imageUrl: "/img/popup_img_success.png",
                imageHeight: 80,
                imageWidth: 80,
                customClass: this.themeDark
                  ? "swal-type-success-dark"
                  : "swal-type-success"
              });

              window.location.reload();
            } else {
              await swal({
                title: "Partner",
                text: "Something went wrong! Please try again.",
                showConfirmButton: false,
                showCloseButton: true,
                customClass: this.themeDark
                  ? "swal-type-error-dark"
                  : "swal-type-error",
                imageUrl: "/img/popup_img_error.png",
                imageHeight: 80,
                imageWidth: 80
              });
            }
          })
          .catch(error => {
            if (error.response.status == 422) {
              this.invites_errors = error.response.data.errors;
            }
          });
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/admin/AddPartner.vue